import { render, staticRenderFns } from "./LawyerServe.vue?vue&type=template&id=6d94ce78&"
import script from "./LawyerServe.vue?vue&type=script&lang=js&"
export * from "./LawyerServe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports